<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="nonindent">Dear Mum</p>
<p class="nonindent">Thank you for all your help. I couldn’t have done it without you.</p>
<p class="right">Love Laura x</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?0096b283